import { render } from "./afterMovies.vue?vue&type=template&id=0eb7df22"
const script = {}

import "./afterMovies.vue?vue&type=style&index=0&id=0eb7df22&lang=css"

import exportComponent from "/var/www/turkey-2026/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__